import { InputSummaryItem } from '../../models/input-summary';
import Utils from '../../util';
import { UnitValue } from '../../models/data-structures/unit-value.model';

export default class InputSummaryUtils {
  static createInputItem(name: string, path: string[], value: string | number | boolean, unit?: string) {
    const inputItem = new InputSummaryItem();
    if (name) {
      if (value || Utils.isNumeric(value) || Utils.isBoolean(value)) {
        inputItem.name = name;
        inputItem.path = path;
        if (Utils.isBoolean(value)) {
          if (value) {
            value = 'PROJECT.COMMON.YES';
          } else {
            value = 'PROJECT.COMMON.NO';
          }
        }
        inputItem.value = value + '';
        if (unit) {
          inputItem.unit = unit;
        } else {
          inputItem.unit = null;
        }
        return inputItem;
      }
    }
    return null;
  }

  static performPush(inputItems: InputSummaryItem[], name, field: any, path: string[]) {
    if (field instanceof UnitValue) {
      const item = field.toInputSummaryItem(name, [...path, 'value']);
      if (item) {
        inputItems.push(item);
      }
    } else {
      const item = InputSummaryUtils.createInputItem(name, path, field);
      if (item) {
        inputItems.push(item);
      }
    }
    return inputItems;
  }
}
